import type { WeddingDetails, WeddingPhoto } from "../shared/contracts";
import galleryImages from "./gallery-images.json";

function galleryPhoto(name: keyof typeof galleryImages, alt: string): WeddingPhoto {
  const image = galleryImages[name];
  const preview = image.variants.find((variant) => variant.width === 640) ?? image.variants[0]!;
  return { ...image, small: preview.webp, full: image.variants.at(-1)!.webp, alt };
}

// Details transcribed from photos/details.jpeg.
export const wedding: WeddingDetails = {
  names: "Naanep & Emmanuel",
  firstName: "Naanep",
  secondName: "Emmanuel",
  fullNames: "Dr. Na'anep Dapoet & Dr. Emmanuel Akintola",
  initials: "N·E",
  dateLabel: "Saturday, 5 December 2026",
  dateShort: "05 / 12 / 2026",
  dateISO: "2026-12-05",
  city: "Abuja, Nigeria",
  ceremonyVenue: "COCIN LCC",
  ceremonyAddress: "Garki Area 1, Abuja",
  receptionVenue: "Maha Event Center",
  receptionAddress: "Area 8, Garki, Abuja",
  ceremonyTime: "10:00 AM",
  rsvpPhones: ["08037051101", "08102310855"],
  gallery: [
    galleryPhoto("garden", "Naanep and Emmanuel walking together outdoors"),
    galleryPhoto("studio", "Naanep and Emmanuel sharing a quiet moment in their studio portraits"),
    galleryPhoto("traditional", "Naanep and Emmanuel in blue traditional attire"),
    galleryPhoto("introduction", "Naanep and Emmanuel smiling at their introduction celebration"),
    galleryPhoto("seated", "Naanep and Emmanuel seated together outdoors"),
    galleryPhoto("dance", "Naanep and Emmanuel dancing outdoors"),
    galleryPhoto("evening", "Naanep and Emmanuel in an elegant studio portrait"),
    galleryPhoto("blue", "Naanep embracing Emmanuel in blue traditional attire"),
    galleryPhoto("intro-close", "Naanep and Emmanuel smiling at their introduction"),
    galleryPhoto("tree", "Naanep and Emmanuel sharing a moment by a tree"),
    galleryPhoto("manchester-bridge", "Naanep and Emmanuel together on a leafy bridge in Manchester"),
    galleryPhoto("manchester-smiles", "Naanep and Emmanuel smiling together in Manchester"),
    galleryPhoto("manchester-dinner", "Naanep and Emmanuel together on an evening out"),
    galleryPhoto("church-portrait", "Naanep and Emmanuel dressed for church")
  ]
};
